import styled from 'styled-components';

import {
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

export const Checkbox = styled(SemanticCheckbox)`
  &&& {
    margin: 0 0 1em;
    display: flex;
    margin-left: 2px;
  }
  &.ui.radio input.hidden+label {
    color: #192C47;
    opacity: 1;
  }
`;
